module.exports = __webpack_public_path__ + "static/media/qrcode.e87ed04d.png";